import React from 'react';

const SVG = ({ style = {}, color, on, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <circle cx="50" cy="50" r="20" fill={color} opacity={on ? 1 : 0} />
    </g>
  </svg>
);

export default SVG;
